// API хранит и пользовательские факты, и внутренние сигналы ранжирования.
// Неизвестные причины не показываем и не заменяем обещанием проверки заказа.
export function visibleFitReasons(reasons) {
  if (!Array.isArray(reasons)) return [];
  const facts = reasons.flatMap((reason) => {
    if (typeof reason !== "string") return [];
    for (const [prefix, label] of [
      ["Услуга: ", "Подходит по услуге: "],
      ["Направление: ", "Подходит по направлению: "],
      ["География: ", "Подходит по месту работы: "],
    ]) {
      if (reason.startsWith(prefix)) {
        const value = reason.slice(prefix.length).trim();
        return value ? [label + value] : [];
      }
    }
    return reason === "Бюджет проходит минимум" ? ["Бюджет подходит под ваши условия"] : [];
  });
  return [...new Set(facts)].slice(0, 2);
}
